module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Grater-9cea9d85c6342ad14588697c88406053.svg";